// extracted by mini-css-extract-plugin
export default {"user-link":"_277bf","userLink":"_277bf","link-banned":"_32fZB","linkBanned":"_32fZB"};